<template>
	<div>
		<template v-if="'URGENT' === componentName">
			<learner-urgent></learner-urgent>
		</template>
		<template v-if="'PROFILE' === componentName">
			<learner-profile-builder></learner-profile-builder>
		</template>
		<template v-if="'EXPLORE_PROGRAM' === componentName">
			<learner-explore-programs></learner-explore-programs>
		</template>
		<template v-if="'EXPLORE_CAREER' === componentName">
			<learner-explore-careers></learner-explore-careers>
		</template>
		<template v-if="'FEED' === componentName">
			<learner-feeds></learner-feeds>
		</template>
		<template v-if="'LMI' === componentName">
			<learner-program-labor-data :program="programGuide"></learner-program-labor-data>
		</template>
    <template v-if="'CAREER-LMI' === componentName">
			<learner-career-labor-data :careerGoal="careerGoal"></learner-career-labor-data>
		</template>
    <template v-if="'CAREER-PATHWAYS' === componentName">
			<learner-career-pathways :careerGoal="careerGoal"></learner-career-pathways>
		</template>
		<template v-if="'REQUIREMENT' === componentName">
			<learner-program-requirement :program="programGuide"></learner-program-requirement>
		</template>
		<!--
    <template v-if="'COURSE_PROGRESS' === componentName">
			<learner-course-progress :program="programGuide"></learner-course-progress >
		</template>
    -->
		<template v-if="'LEARNING' === componentName">
			<learner-program-course-learn :program="programGuide"></learner-program-course-learn>
		</template>
    <template v-if="'SIS_PENDING' === componentName">
			<learner-application-pending></learner-application-pending>
		</template>
		<template v-if="'COMPETENCY_PROGRESS' === componentName">
			<learner-program-competency-progress :program="programGuide"></learner-program-competency-progress>
		</template>
	</div>
</template>

<script>
	import LearnerFeeds from './LearnerFeeds'
  import LearnerUrgent from './LearnerUrgent'
	import LearnerProfileBuilder from './LearnerProfileBuilder'
	import LearnerExploreCareers from './LearnerExploreCareers'
	import LearnerExplorePrograms from './LearnerExplorePrograms'
	import LearnerProgramLaborData from './LearnerProgramLaborData'
  import LearnerCareerLaborData from './LearnerCareerLaborData'
  import LearnerCareerPathways from './LearnerCareerPathways'
	import LearnerProgramRequirement from './LearnerProgramRequirement'
  import LearnerProgramCourseLearn from './LearnerProgramCourseLearn'
  import LearnerProgramCompetencyProgress from './LearnerProgramCompetencyProgress'
  import LearnerApplicationPending from './LearnerApplicationPending'

	export default {
	  name: 'component-logic',
	  props: ['componentName','programGuide','careerGoal'],
	  components: {
      LearnerUrgent,
	  	LearnerFeeds,
      LearnerProfileBuilder,
      LearnerExploreCareers,
      LearnerExplorePrograms,
      LearnerProgramLaborData,
      LearnerCareerLaborData,
      LearnerCareerPathways,
      LearnerProgramRequirement,
      LearnerProgramCourseLearn,
      LearnerProgramCompetencyProgress,
      LearnerApplicationPending
    }
	}
</script>



// WEBPACK FOOTER //
// src/app/dashboard/components/ComponentLogic.vue